import useApi, { ApiOptions } from '../base/useApi';
import HospitalDTO from '@src/adapters/dto/hospital/HospitalDTO';

interface Params {}

interface Result {
  hospitals: HospitalDTO[];
}

const options: ApiOptions = {
  method: 'get',
  urlPath: '/hospital/all/',
  baseUrl: process.env.REACT_APP_API_URL!,
  lazy: false,
};

export const useFindHospitalsAllLazy = (params?: Params) => {
  options.lazy = true;
  return useApi<Params, Result>(options, params);
};

export default useFindHospitalsAllLazy;
